
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/iletisim');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#007dff]/5 via-white to-[#007dff]/5">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #007dff 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Gradient Orbs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-deep-cyan/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-deep-cyan/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-8 py-20 lg:py-0">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="font-poppins font-semibold text-[12px] text-[#007dff] uppercase tracking-wider mb-4"
            >
              Sigorta Sektörüne Özel Dijital Ajans
            </motion.p>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="font-poppins font-bold text-4xl lg:text-5xl text-gray-900 mb-5 leading-tight lg:leading-[1.2]"
            >
              Sigorta Acentenizi Dijitalde{' '}
              <span className="text-[#007dff]">Zirveye Taşıyoruz</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="font-poppins text-base text-gray-600 mb-8 leading-relaxed"
            >
              Sosyal medya yönetiminden Google reklamlarına, web tasarımından CRM entegrasyonuna kadar tüm dijital ihtiyaçlarınız için tek adres. Sigorta dilini bilen, sonuç odaklı çözümler.
            </motion.p>

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="flex flex-wrap gap-4 mb-10"
            >
              <button
                onClick={scrollToContact}
                className="px-7 py-3 bg-gradient-to-r from-[#007dff] to-[#0066dd] text-white text-[14px] font-semibold rounded-xl hover:shadow-xl hover:shadow-[#007dff]/30 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 active:scale-95 font-poppins"
              >
                Ücretsiz Analiz Al
              </button>
              <Link
                to="/hizmetler"
                className="px-7 py-3 bg-white text-[#007dff] text-[14px] font-semibold rounded-xl border-2 border-[#007dff] hover:bg-[#007dff] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 active:scale-95 font-poppins"
              >
                Hizmetleri Keşfet
              </Link>
            </motion.div>

            {/* Stats */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="flex flex-wrap gap-6"
            >
              {[
                { number: '50+', label: 'Aktif Acente' },
                { number: '5 Yıl', label: 'Sektör Deneyimi' },
                { number: '%180', label: 'Ortalama Büyüme' },
              ].map((stat, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-1 h-10 bg-gradient-to-b from-[#007dff] to-[#0066dd] rounded-full"></div>
                  <div>
                    <p className="font-poppins font-bold text-xl text-gray-900">{stat.number}</p>
                    <p className="font-poppins text-[12px] text-gray-600">{stat.label}</p>
                  </div>
                </div>
              ))}
            </motion.div>
          </motion.div>

          {/* Right Content - Performance Dashboard */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="relative px-4 sm:px-0"
          >
            {/* Main Dashboard Card */}
            <div className="bg-white rounded-2xl shadow-xl p-4 sm:p-6 border border-gray-100">
              {/* Header */}
              <div className="flex items-center justify-between mb-5">
                <div>
                  <h3 className="font-poppins font-bold text-sm sm:text-base text-gray-900">Performans Özeti</h3>
                  <p className="font-poppins text-[11px] text-gray-500">Son 30 Gün</p>
                </div>
                <div className="w-10 h-10 flex items-center justify-center bg-[#007dff]/10 rounded-xl flex-shrink-0">
                  <i className="ri-line-chart-line text-lg text-[#007dff]"></i>
                </div>
              </div>

              {/* Metrics Grid */}
              <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-5">
                {[
                  { icon: 'ri-user-add-line', label: 'Yeni Lead', value: '847', change: '+24%', color: '#007dff' },
                  { icon: 'ri-exchange-line', label: 'Dönüşüm', value: '%18.5', change: '+8.2%', color: '#007dff' },
                  { icon: 'ri-eye-line', label: 'Görüntüleme', value: '45.2K', change: '+156%', color: '#007dff' },
                  { icon: 'ri-heart-line', label: 'Etkileşim', value: '12.8K', change: '+89%', color: '#007dff' },
                ].map((metric, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.4, delay: 0.5 + index * 0.1 }}
                    className="bg-gradient-to-br from-[#007dff]/5 to-[#007dff]/10 rounded-xl p-2.5 sm:p-3 hover:shadow-md transition-all duration-300 cursor-pointer group"
                  >
                    <div className="flex items-center gap-1.5 sm:gap-2 mb-2">
                      <div className="w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center bg-white rounded-lg group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                        <i className={`${metric.icon} text-xs sm:text-sm`} style={{ color: metric.color }}></i>
                      </div>
                      <span className="font-poppins text-[9px] sm:text-[10px] text-gray-600">{metric.label}</span>
                    </div>
                    <p className="font-poppins font-bold text-base sm:text-lg text-gray-900 mb-1">{metric.value}</p>
                    <div className="flex items-center gap-1">
                      <i className="ri-arrow-up-line text-[10px] text-green-600"></i>
                      <span className="font-poppins text-[10px] text-green-600 font-semibold">{metric.change}</span>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Progress Bars */}
              <div className="space-y-3">
                {[
                  { label: 'Sosyal Medya', progress: 85, color: '#007dff' },
                  { label: 'Google Ads', progress: 92, color: '#007dff' },
                  { label: 'Web Trafiği', progress: 78, color: '#007dff' },
                ].map((item, index) => (
                  <div key={index}>
                    <div className="flex items-center justify-between mb-1.5">
                      <span className="font-poppins text-[10px] sm:text-[11px] text-gray-700 font-medium">{item.label}</span>
                      <span className="font-poppins text-[10px] sm:text-[11px] text-gray-900 font-bold">{item.progress}%</span>
                    </div>
                    <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                      <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: `${item.progress}%` }}
                        transition={{ duration: 1, delay: 0.8 + index * 0.2 }}
                        className="h-full rounded-full"
                        style={{ backgroundColor: item.color }}
                      ></motion.div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Floating Badges */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 1 }}
              className="absolute -top-3 -right-0 sm:-right-3 bg-gradient-to-br from-[#007dff] to-[#0066dd] text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl shadow-lg"
            >
              <p className="font-poppins text-[10px] sm:text-[11px] font-bold">%180 Büyüme</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 1.2 }}
              className="absolute -bottom-3 -left-0 sm:-left-3 bg-white border-2 border-[#007dff] text-[#007dff] px-3 sm:px-4 py-1.5 sm:py-2 rounded-xl shadow-lg"
            >
              <p className="font-poppins text-[10px] sm:text-[11px] font-bold">120+ Acente</p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
